// Fakturadetaljer (no).
window.PlummeI18n.register('no', {
  'inv.detail.completion': 'Gjennomføring',
  'inv.detail.completed': 'Gjennomført',
  'inv.detail.notCompleted': 'Ikke gjennomført',
  'inv.detail.paymentStatus': 'Betalingsstatus',
  'inv.detail.paid': 'Betalt',
  'inv.detail.remaining': 'Gjenstår',
  'inv.detail.registeredPayments': 'Registrerte betalinger',
  'inv.detail.registerPayment': 'Registrer betaling',
  'inv.detail.settlementStatus': 'Oppgjør',
  'inv.detail.creditOffset': 'Motregnet',
  'inv.detail.creditRefunded': 'Tilbakebetalt',
  'inv.detail.creditOpen': 'Ikke tilbakebetalt',
  'inv.detail.offsetAgainst': 'Motregnet mot {document}',
  'inv.detail.offsetAgainstInvoice': 'Motregnet mot fakturaen',
  'inv.detail.refunded': 'Tilbakebetalt',
  'inv.detail.toCredit': 'Til gode',
  'inv.detail.registeredRefunds': 'Registrerte tilbakebetalinger',
  'inv.detail.registerRefund': 'Registrer tilbakebetaling',
  'inv.detail.amountTitle': 'Beløp',
  'inv.detail.amountHelp': 'Netto, MVA og totalbeløp er beregnet fra de lagrede fakturalinjene.',
  'inv.detail.net': 'Netto',
  'inv.detail.totalAmount': 'Totalt beløp',
  'inv.detail.history': 'Historikk',
  'inv.detail.action': 'Handling',
  'inv.detail.loadingDoc': 'Laster dokument...',
  'inv.detail.openedFromLink': 'Dokument åpnet fra lenke',

  'inv.act.open': 'Åpne',
  'inv.act.openHelp': 'Åpne utkastet i Nytt salg for å redigere og sende det.',
  'inv.act.send': 'Send',
  'inv.act.sendAgain': 'Send på nytt',
  'inv.act.sendCreditNote': 'Send kreditnota',
  'inv.act.sendHelp': 'Send dokumentet til kunden på e-post via backend.',
  'inv.act.markDelivered': 'Marker som levert',
  'inv.act.markDeliveredHelp': 'Bruk når dokumentet er levert til kunden utenfor Plumme.',
  'inv.act.view.invoice': 'Se faktura',
  'inv.act.view.quote': 'Se tilbud',
  'inv.act.view.orderConfirmation': 'Se ordrebekreftelse',
  'inv.act.view.creditNote': 'Se kreditnota',
  'inv.act.viewHelp': 'Forhåndsvis dokumentet slik kunden ser det.',
  'inv.act.copyLink': 'Kopier lenke',
  'inv.act.copyLinkHelp': 'Kopier en delbar lenke til dokumentet.',
  'inv.act.download': 'Last ned',
  'inv.act.downloadHelp': 'Last ned dokumentet som PDF.',
  'inv.act.packingSlip': 'Lag pakkseddel',
  'inv.act.packingSlipHelp': 'Lag og last ned en pakkseddel for varene på denne fakturaen.',
  'inv.act.copy': 'Lag kopi',
  'inv.toast.copyOpened': 'Kopien er åpnet — lagre den som utkast eller opprett den',
  'inv.act.share': 'Del',
  'inv.act.shareHelp': 'Kopier delingslenke, last ned PDF eller lag pakkseddel.',
  'inv.share.title': 'Del dokumentet',
  'inv.act.convertOffer': 'Opprett',
  'inv.act.convertOfferHelp': 'Lager en faktura eller ordrebekreftelse som utkast, med kunden og linjene fra tilbudet.',
  'inv.convert.title': 'Opprett fra tilbudet',
  'inv.convert.invoice': 'Faktura',
  'inv.convert.invoiceHelp': 'Vanlig betalingsfrist. Bokføres når du oppretter den.',
  'inv.convert.order': 'Ordrebekreftelse',
  'inv.convert.orderHelp': 'Bekrefter avtalen uten å fakturere. Kan faktureres senere.',
  'inv.act.markAccepted': 'Sett som akseptert',
  'inv.act.markAcceptedHelp': 'Bruk denne når kunden har godtatt tilbudet muntlig, i et møte eller på e-post. Aksept kunden gjør selv i tilbudslenken registreres automatisk.',
  'inv.act.undoAccepted': 'Fjern aksept',
  'inv.act.undoAcceptedHelp': 'Angrer en aksept som ble registrert her i appen. Aksept kunden selv har trykket kan ikke fjernes.',
  'inv.act.copyHelp': 'Lag en ny faktura med samme innhold som denne.',
  'inv.act.credit': 'Krediter',
  'inv.act.creditHelp': 'Lag en kreditnota som motregner denne fakturaen.',
  'inv.act.delete': 'Slett',
  'inv.act.deleteHelp': 'Slett dette utkastet. Kan ikke angres.',

  'inv.err.actionFailed': 'Handlingen kunne ikke fullføres.',
  'inv.err.openDoc': 'Kunne ikke åpne dokumentet.',
  'inv.err.previewPacking': 'Kunne ikke forhåndsvise pakkseddel.',
  'inv.err.settleNotConnected': 'Oppgjør uten betaling er ikke koblet til backend.',
  'inv.err.settleFailed': 'Kunne ikke oppgjøre uten betaling.',
  'inv.err.needEmail': 'Legg inn mottaker-e-post først.',
  'inv.err.emailCharset': 'E-postadresser kan ikke inneholde æ, ø, å eller andre spesialtegn.',
  'inv.err.invalidEmail': 'Dette ser ikke ut som en gyldig e-postadresse.',
  'inv.err.acceptNotConnected': 'Aksept er ikke koblet til backend.',
  'inv.err.acceptFailed': 'Kunne ikke oppdatere aksepten.',
  'inv.err.convertNotConnected': 'Konvertering er ikke koblet til backend.',
  'inv.err.convertOpenFailed': 'Utkastet ble laget, men kunne ikke åpnes.',
  'inv.err.convertFailed': 'Kunne ikke opprette dokumentet fra tilbudet.',
  'inv.err.copyOpenFailed': 'Kopien ble opprettet, men kunne ikke åpnes.',
  'inv.err.deleteNotConnected': 'Sletting er ikke koblet til backend.',
  'inv.err.deleteFailed': 'Kunne ikke slette utkastet.',
  'inv.toast.onlyDrafts': 'Bare utkast kan slettes her',
  'inv.toast.offerAccepted': 'Tilbudet er satt som akseptert',
  'inv.toast.offerAcceptanceRemoved': 'Aksepten er fjernet',
  'inv.toast.invoiceDraftFromOffer': 'Fakturaen er åpnet — lagre den som utkast eller opprett den',
  'inv.toast.orderDraftFromOffer': 'Ordrebekreftelsen er åpnet — lagre den som utkast eller opprett den',
  'inv.toast.draftDeleted': 'Utkast slettet',

  'inv.pay.settleWithout': 'Oppgjort uten betaling',
  'inv.pay.saveChange': 'Lagre endring',
  'inv.pay.paidDate': 'Betalt dato',
  'inv.pay.datePh': 'dd.mm.åååå',
  'inv.pay.registerPaymentTitle': 'Registrer betaling',
  'inv.pay.editPaymentTitle': 'Rediger betaling',
  'inv.pay.registerRefundTitle': 'Registrer tilbakebetaling',
  'inv.pay.editRefundTitle': 'Rediger tilbakebetaling',
  'inv.pay.paidFrom': 'Betalt fra',
  'inv.pay.refundDate': 'Tilbakebetalt dato',
  'inv.pay.refundAmount': 'Tilbakebetalt beløp',
  'inv.pay.remainingNote': 'Gjenstående på fakturaen: {amount}. Du kan registrere en delbetaling.',
  'inv.pay.refundNote': 'Kunden har {amount} til gode på kreditnotaen. Du kan registrere en delvis tilbakebetaling.',
  'inv.pay.refundHelp': 'Kreditnotaen reverserer salget uansett. Registrer tilbakebetaling bare når kunden faktisk får penger tilbake.',
  'inv.pay.fee': 'Bank- og kortgebyr',
  'inv.pay.feeAccount': 'Gebyrkonto',
  'inv.pay.bankAmountIn': 'Faktisk beløp inn på bank: {amount}',
  'inv.pay.bankAmountOut': 'Faktisk beløp ut av bank: {amount}',
  'inv.detail.offsetCustomerCredit': 'Motregn kundetilgode',
  'inv.detail.customerCreditOffset': 'Motregnet kundetilgode',
  'inv.detail.customerCreditAllocated': 'Motregnet mot annen faktura',
  'inv.detail.relatedRefund': 'Tilbakebetalt via tilhørende kreditnota',
  'inv.toast.customerCreditOffset': 'Kundetilgode er motregnet mot fakturaen',
  'inv.err.noCustomerCredit': 'Ingen tilgjengelig kundekreditnota ble funnet.',
  'inv.err.customerCreditOffsetFailed': 'Kunne ikke motregne kundetilgode.',
  'cust.ledger.creditOffset': 'Motregnet kundetilgode',
  'inv.toast.paymentRegistered': 'Innbetaling registrert',
  'inv.toast.paymentUpdated': 'Betaling oppdatert',
  'inv.toast.refundRegistered': 'Tilbakebetaling registrert',
  'inv.toast.refundUpdated': 'Tilbakebetaling oppdatert',
  'inv.err.paymentFailed': 'Kunne ikke registrere innbetalingen.',
  'inv.err.paymentUpdateFailed': 'Kunne ikke oppdatere betalingen.',
  'inv.err.refundFailed': 'Kunne ikke registrere tilbakebetalingen.',
  'inv.err.refundUpdateFailed': 'Kunne ikke oppdatere tilbakebetalingen.',

  'inv.del.confirm': 'Ja, slett utkast',
  'inv.del.body': 'Er du sikker på at du vil slette dette utkastet for {customer}? Dette kan ikke angres.',
  'inv.send.body': '{document} på {amount} sendes til {customer} som PDF på e-post.',
  'inv.send.resendNote': ' Dette er en ny sending av et allerede sendt dokument.',

  'inv.credit.continue': 'Til kreditering',
  'inv.credit.intro': 'En kreditnota motregner fakturaen for {customer}. Velg om du vil kreditere hele fakturaen eller bare deler av den.',
  'inv.credit.full': 'Full kreditering',
  'inv.credit.partial': 'Delkreditering',
  'inv.credit.line': 'Linje',
  'inv.credit.count': 'Antall',
  'inv.credit.credited': 'Krediteres',
  'inv.credit.total': 'Kreditnotaens beløp',
  'inv.credit.breakdown': 'Netto {net} · MVA {vat}',
  'inv.credit.partialSuffix': ' · delkreditering',
  'inv.delivery.rowFailed': 'Kom ikke fram',
  'inv.delivery.bannerTitle': '{n} dokumenter kom ikke fram til mottakeren',
  'inv.delivery.bannerBody': 'E-posten ble avvist eller kom i retur: {documents}. Åpne dokumentet, rett e-postadressen på kunden og send på nytt.',
  'inv.credit.rest': 'Krediter resten',
  'inv.credit.alreadyCredited': 'Allerede kreditert: {amount}. Du kan bare kreditere det som står igjen.',
  'inv.credit.closedLines': '{n} linjer er ferdig kreditert og vises ikke.',
  'inv.credit.lineAlready': 'kreditert {amount}',
  'inv.credit.hasPayments': 'Fakturaen har registrerte betalinger. Kreditnotaen motregner det åpne beløpet; en eventuell tilbakebetaling registreres for seg.',
  'inv.credit.date': 'Kreditnotadato',
  'inv.credit.dateHint': 'Datoen bestemmer hvilken regnskaps- og MVA-periode krediteringen føres i.',
  'inv.credit.dateBeforeInvoice': 'Kreditnotadatoen kan ikke v?re f?r fakturadatoen.',
  'inv.credit.invalidDate': 'Velg en gyldig kreditnotadato.',
  'inv.credit.paidConfirmTitle': 'Fakturaen er betalt',
  'inv.credit.paidConfirmBody': 'Vi ser at fakturaen har registrerte innbetalinger på {amount}. Kreditnotaen reverserer salget, men en eventuell tilbakebetaling registreres separat. Vil du fortsette?',
  'inv.credit.paidConfirmContinue': 'Ja, fortsett krediteringen',
  'inv.bulk.creditDateHint': 'Samme dato brukes på alle kreditnotaene. Datoen bestemmer regnskaps- og MVA-perioden.',
  'inv.bulk.creditDateBeforeInvoices': 'Datoen kan ikke v?re f?r den seneste fakturadatoen i utvalget.',
  'inv.bulk.creditPaidConfirmBody': '{n} av de valgte fakturaene har registrerte innbetalinger. Kreditnotaene reverserer salgene, men eventuelle tilbakebetalinger registreres separat. Vil du fortsette?',
  'inv.history.creditPartial': 'Delkreditert {amount} · kreditnota {document}',
  'inv.history.creditFull': 'Kreditert {amount} · kreditnota {document}',
  'inv.history.creditDraft': 'Kreditnota {document} opprettet som utkast · {amount}',
  'inv.history.creditNoNumber': 'uten nummer',
  'inv.toast.creditOpened': 'Kreditnota for {document} er åpnet — fyll ut årsak og opprett den',
  'inv.toast.partialCreditOpened': 'Delkreditnota for {document} er åpnet — fyll ut årsak og opprett den',

  'inv.bulk.selectAll': 'Velg alle som vises',
  'inv.bulk.selectRow': 'Velg dokument. Shift-klikk velger intervallet.',
  'inv.bulk.selectDocument': 'Velg dokument',
  'inv.bulk.selectDocuments': 'Velg dokumenter',
  'inv.bulk.selectedCount': '{n} valgt',
  'inv.bulk.shownCount': '{n} vises i listen',
  'inv.bulk.reset': 'Nullstill',
  'inv.bulk.deliver': 'Marker som levert',
  'inv.bulk.resend': 'Send på nytt',
  'inv.bulk.reminder': 'Purring',
  'inv.bulk.credit': 'Krediter',
  'inv.bulk.issue': 'Opprett og send',
  'inv.bulk.delete': 'Slett',
  'inv.bulk.processing': 'Behandler ...',
  'inv.bulk.document': 'Dokument',
  'inv.bulk.amount': 'Beløp',
  'inv.bulk.more': '+ {n} flere',
  'inv.bulk.noEmail': 'mangler e-post',
  'inv.bulk.newDueDate': 'ny frist {date}',
  'inv.bulk.reminderType': 'Type',
  'inv.bulk.reminderNotice': 'Betalingspåminnelse',
  'inv.bulk.reminderDunning': 'Purring',
  'inv.bulk.reminderDueDays': 'Dager til ny frist',
  'inv.bulk.reminderFee': 'Purregebyr',
  'inv.bulk.reminderFeeLocked': 'Gebyr kan bare legges på ved purring.',
  'inv.bulk.delivery': 'Sendes som',
  'inv.bulk.deliveryPdf': 'PDF-vedlegg',
  'inv.bulk.deliveryLink': 'Lenke',
  'inv.bulk.comment': 'Kommentar til kunden',
  'inv.bulk.commentHint': 'Står i e-posten sammen med beløpsoversikten. Selve fakturaen endres ikke.',
  'inv.bulk.commentPh': 'For eksempel: Vi ser at fakturaen står ubetalt. Ta kontakt hvis noe er uklart.',
  'inv.comment.label': 'Kommentar til kunden',
  'inv.comment.hint': 'Valgfri tekst som følger denne utsendelsen.',
  'inv.comment.placeholder': 'Skriv en kommentar ...',
  'inv.comment.useSaved': 'Bruk kommentar',
  'inv.comment.save': 'Lagre kommentar',
  'inv.comment.update': 'Oppdater kommentar',
  'inv.comment.saveTitle': 'Lagre kommentar',
  'inv.comment.updateTitle': 'Oppdater kommentar',
  'inv.comment.saveAsNew': 'Lagre som ny',
  'inv.comment.savedTitle': 'Lagrede kommentarer',
  'inv.comment.name': 'Navn på kommentaren',
  'inv.comment.namePh': 'For eksempel: Vennlig påminnelse',
  'inv.comment.nameHint': 'Navnet er det du finner kommentaren igjen på i lista.',
  'inv.comment.needName': 'Gi kommentaren et navn først',
  'inv.comment.empty': 'Du har ingen lagrede kommentarer ennå.',
  'inv.comment.use': 'Bruk',
  'inv.comment.saved': 'Kommentar lagret',
  'inv.comment.updated': 'Kommentar oppdatert',
  'inv.comment.deleted': 'Kommentar slettet',
  'inv.comment.saveFailed': 'Kunne ikke lagre kommentaren.',
  'inv.comment.deleteFailed': 'Kunne ikke slette kommentaren.',
  'inv.comment.notConnected': 'Kommentarer er ikke koblet til backend.',
  'inv.bulk.mode': 'Hva skal skje',
  'inv.bulk.mode.draft': 'Lagre som utkast',
  'inv.bulk.mode.send': 'Opprett og send',
  'inv.bulk.mode.create': 'Bare opprett',
  'inv.bulk.mode.hint.credit': 'Kreditnotaene legges i utkast-fanen. Ingenting blir bokført eller sendt før du oppretter dem.',
  'inv.bulk.mode.hint.creditSend': 'Kreditnotaene blir bokført og sendt til kundene med én gang. Dette kan ikke angres.',
  'inv.bulk.mode.hint.issueSend': 'Utkastene blir bokført med dokumentnummer og sendt til kundene på e-post.',
  'inv.bulk.mode.hint.issue': 'Utkastene blir bokført med dokumentnummer, men ingen e-post går ut.',
  'inv.bulk.creditReasonOptional': 'Valgfritt så lenge kreditnotaen ligger som utkast. Årsaken må være på plass før den kan bokføres.',
  'inv.bulk.creditReasonRequired': 'Påkrevd. Årsaken står på kreditnotaen og er grunnlaget for at salget ble reversert.',
  'inv.bulk.title.deliver': 'Marker valgte dokumenter som levert',
  'inv.bulk.title.send': 'Send valgte dokumenter på nytt',
  'inv.bulk.title.reminder': 'Send purring eller betalingspåminnelse',
  'inv.bulk.title.credit': 'Krediter valgte fakturaer',
  'inv.bulk.title.issue': 'Opprett valgte utkast',
  'inv.bulk.title.delete': 'Slett valgte utkast',
  'inv.bulk.confirm.deliver': 'Marker som levert',
  'inv.bulk.confirm.send': 'Send på nytt',
  'inv.bulk.confirm.reminder': 'Send oppfølging',
  'inv.bulk.confirm.credit': 'Opprett kreditnotaer',
  'inv.bulk.confirm.creditSend': 'Opprett og send kreditnotaer',
  'inv.bulk.confirm.issue': 'Opprett dokumentene',
  'inv.bulk.confirm.issueSend': 'Opprett og send',
  'inv.bulk.confirm.delete': 'Ja, slett utkastene',
  'inv.bulk.body.deliver': 'Dokumenter som markeres som levert utenfor Plumme: {n}. Ingen e-post sendes, og bokføring og betaling endres ikke.',
  'inv.bulk.body.send': '{n} dokumenter sendes med e-postadressen som ligger på kunden.',
  'inv.bulk.body.reminder': '{n} forfalte eller ubetalte fakturaer følges opp. Originalfakturaen bokføres ikke på nytt.',
  'inv.bulk.body.credit': '{n} fakturaer krediteres for det som gjenstår, én kreditnota per faktura. Allerede krediterte linjer tas ikke med på nytt.',
  'inv.bulk.body.creditSend': '{n} fakturaer krediteres for det som gjenstår. Kreditnotaene blir opprettet, bokført og sendt til kunden med én gang — du slipper å gå via utkast.',
  'inv.bulk.body.issue': '{n} utkast blir opprettet og bokført, og får dokumentnummer.',
  'inv.bulk.body.issueSend': '{n} utkast blir opprettet, bokført og sendt til kunden på e-post.',
  'inv.bulk.body.delete': '{n} utkast blir slettet. Utkast er ikke bokført, men slettingen kan ikke angres.',
  'inv.bulk.skip.deliver': 'Valgte rader som er utkast, allerede levert eller sendt, og hoppes over: {n}.',
  'inv.bulk.skip.send': '{n} valgte dokumenter mangler e-post og hoppes over.',
  'inv.bulk.skip.reminder': '{n} valgte rader kan ikke purres her eller mangler e-post.',
  'inv.bulk.skip.credit': '{n} valgte rader kan ikke krediteres her.',
  'inv.bulk.skip.issue': '{n} valgte utkast mangler kunde eller linjer, og kan ikke opprettes herfra.',
  'inv.bulk.skip.noEmail': '{n} av dokumentene mangler e-postadresse. De blir opprettet og bokført, men ikke sendt.',
  'inv.bulk.skip.delete': '{n} valgte rader er ikke utkast og slettes ikke.',
  'inv.bulk.toast.delivered': 'Dokumenter markert som levert: {n}',
  'inv.bulk.toast.sent': '{n} dokumenter sendt',
  'inv.bulk.toast.reminded': '{n} betalingspåminnelser sendt',
  'inv.bulk.toast.dunned': '{n} purringer sendt',
  'inv.bulk.toast.credited': '{n} kreditnotaer opprettet som utkast',
  'inv.bulk.toast.creditedSent': '{n} kreditnotaer opprettet og sendt',
  'inv.bulk.toast.issued': '{n} dokumenter opprettet',
  'inv.bulk.toast.issuedSent': '{n} dokumenter opprettet og sendt',
  'inv.bulk.toast.deleted': '{n} utkast slettet',
  'inv.bulk.toast.notSentSuffix': ', {n} opprettet uten e-post',
  'inv.bulk.toast.failedSuffix': ', {n} feilet',
  'inv.bulk.err.failed': 'Kunne ikke fullføre massehandlingen.',
  'inv.bulk.err.deliverNotConnected': 'Markering som levert er ikke koblet til backend.',
  'inv.bulk.err.sendNotConnected': 'Sending er ikke koblet til backend.',
  'inv.bulk.err.creditNotConnected': 'Kreditering er ikke koblet til backend.',
  'inv.bulk.err.issueNotConnected': 'Oppretting av utkast er ikke koblet til backend.',

  'inv.packing.preview': 'Forhåndsvis',
  'inv.packing.download': 'Last ned pakkseddel',
  'inv.packing.invoiceDate': 'Fakturadato',

  'inv.pay.account.1920': 'Driftskonto - 1920',
  'inv.pay.account.2063': 'Privat - 2063',
  'inv.pay.account.1900': 'Kontanter - 1900',

  'inv.report.customer': 'Kunde',
  'inv.report.product': 'Produkt',
  'inv.report.salesCount': 'Antall salg',
  'inv.report.count': 'Antall',
  'inv.report.exVat': 'Ekskl. mva.',
  'inv.report.share': 'Andel av total',
  'inv.report.noSales': 'Ingen salg i perioden.',
  'inv.report.noProducts': 'Ingen produkter solgt i perioden.',
  'inv.report.openCustomer': 'Åpne {name} i Kunder',
  'inv.report.totalCustomers': '({n} kunder)',
  'inv.report.totalCustomer': '({n} kunde)',
  'inv.report.totalProducts': '({n} produkter)',
  'inv.report.totalProduct': '({n} produkt)',
  'inv.report.total': 'Totalt',
  'inv.report.tile.sales': 'Salg',
  'inv.report.tile.activeCustomers': 'Aktive kunder',
  'inv.report.tile.newCustomers': 'Nye kunder',
  'inv.report.tile.totalCustomers': 'Kunder totalt',
  'inv.report.tile.customerRevenue': 'Kundeinntekter',
  'inv.report.tile.totalRevenue': 'Totale inntekter',
  'inv.report.tile.soldProducts': 'Solgte produkter',
  'inv.report.tile.productTypes': 'Produkttyper',
  'inv.report.tile.productRevenue': 'Produktinntekter',
  'inv.report.unknownCustomer': 'Ukjent kunde',
  'inv.report.unspecifiedSale': 'Uspesifisert salg',
  'inv.report.customerSummaryOne': 'Det ble registrert {sales} salg til {customers} kunde i perioden. Salg til kunder utgjorde {amount}.',
  'inv.report.customerSummaryMany': 'Det ble registrert {sales} salg til {customers} kunder i perioden. Salg til kunder utgjorde {amount}.',
  'inv.report.productSummaryOne': 'Det ble solgt {count} produkter/linjer i perioden av {types} type produkt, for totalt {amount}.',
  'inv.report.productSummaryMany': 'Det ble solgt {count} produkter/linjer i perioden av {types} typer produkt, for totalt {amount}.',
  'inv.fallback.noCustomer': 'Uten kunde',
  'inv.fallback.line': 'Linje {n}',
  'inv.credit.fallbackDescription': 'Salg iht. {document}',
  'inv.credit.dialogTitle': 'Krediter faktura {number}',
  'inv.detail.validUntil': 'Gyldig til',
  'inv.detail.dueDate': 'Forfall',
  'inv.detail.partiallyPaid': 'Delvis betalt',
  'inv.detail.unpaid': 'Ikke betalt',
  'inv.detail.acceptedManual': 'Akseptert {date} · registrert i appen',
  'inv.detail.acceptedCustomer': 'Akseptert {date} · av kunden',
  'inv.detail.orderSentAt': 'Ordrebekreftelse sendt {date}',
  'inv.detail.paymentFeeBank': 'Gebyr {fee} · Bank {bank}',
  'inv.detail.deliveryFailureHelp': 'Dokumentet er lagret, men mottakeren har ikke fått det. Rett adressen på kunden og send på nytt.',
  'inv.detail.timelineHelp': 'Tidslinje bygget fra lagret dokumentstatus og betalinger.',
  'inv.history.offerAcceptedManual': 'Tilbud satt som akseptert (registrert i appen)',
  'inv.history.offerAcceptedCustomer': 'Tilbud akseptert av kunden',
  'inv.history.orderSent': 'Ordrebekreftelse sendt',
  'inv.history.documentSentTo': '{document} sendt til {recipient}',
  'inv.history.deliveredExternally': 'Levert utenfor Plumme',
  'inv.history.documentCreated': 'Dokument opprettet',
  'inv.packing.intro': 'Sett dato for utsending. Dagens dato er satt som standard.',
  'inv.packing.shippingDate': 'Utsendingsdato',
  'inv.packing.contents': 'Pakkseddelen viser beskrivelser og antall fra fakturalinjene. Priser, MVA og betalingsinformasjon blir ikke vist.',
  'inv.packing.title': 'Pakkseddel {number}',
  'inv.err.pdfPreviewNotConnected': 'PDF-visning er ikke koblet til backend.',
  'inv.err.packingNotConnected': 'Pakkseddel er ikke koblet til backend.',
  'inv.err.packingDownloadFailed': 'Kunne ikke laste ned pakkseddel.',
  'inv.err.paymentNotConnected': 'Innbetaling er ikke koblet til backend.',
  'inv.err.paymentEditNotConnected': 'Betalingsredigering er ikke koblet til backend.',
  'inv.err.sendNotConnected': 'Sending er ikke koblet til backend.',
  'inv.err.sendFailed': 'Kunne ikke sende dokumentet.',
  'inv.err.deliverNotConnected': 'Markering som levert er ikke koblet til backend.',
  'inv.err.deliverFailed': 'Kunne ikke markere dokumentet som levert.',
  'inv.err.linkNotConnected': 'Fakturalenke er ikke koblet til backend.',
  'inv.err.linkFailed': 'Kunne ikke hente fakturalenke.',
  'inv.err.downloadNotConnected': 'PDF-nedlasting er ikke koblet til backend.',
  'inv.err.downloadFailed': 'Kunne ikke laste ned dokumentet.',
  'inv.err.copyNotConnected': 'Kopiering er ikke koblet til backend.',
  'inv.err.copyFailed': 'Kunne ikke lage kopi av dokumentet.',
  'inv.err.archiveNotConnected': 'Arkivering er ikke koblet til backend.',
  'inv.err.archiveFailed': 'Kunne ikke oppdatere arkivstatus.',
  'inv.err.creditNotConnected': 'Kreditering er ikke koblet til backend.',
  'inv.err.creditFailed': 'Kunne ikke opprette kreditnota.',
  'inv.toast.packingDownloading': 'Pakkseddel lastes ned',
  'inv.toast.settledWithoutPayment': 'Fakturaen er oppgjort uten betaling',
  'inv.toast.sendingBackground': '{document} sendes i bakgrunnen',
  'inv.toast.documentSent': '{document} sendt',
  'inv.toast.deliveredExternally': 'Dokumentet er markert som levert',
  'inv.toast.readyNoEmail': 'Dokumentet er klargjort, men ingen e-post ble sendt.',
  'inv.toast.linkCopied': 'Lenke til {number} kopiert',
  'inv.toast.documentDownloading': 'Dokumentet lastes ned',
  'inv.toast.archiveRestored': 'Hentet ut av arkiv',
  'inv.toast.archived': 'Arkivert',
  'inv.toast.creditCreated': '{document} opprettet for {number}',
  'inv.act.unarchive': 'Hent ut av arkiv',
  'inv.act.archive': 'Arkiver',
  'inv.act.archiveHelp': 'Flytt tilbudet eller ordrebekreftelsen til arkiv, eller hent det ut igjen.',
  'inv.convert.alreadyTitle': 'Tilbudet er allerede gjort om til:',
  'inv.convert.duplicateWarning': 'Oppretter du et til, må du selv passe på at kunden ikke blir fakturert for samme jobb to ganger.',
  'inv.convert.footerHelp': 'Begge lages som utkast med kunden og linjene fra tilbudet, og åpnes i salgsflyten.',
  'inv.send.title': 'Send {document} {number}',
  'inv.deliver.title': 'Marker som levert',
  'inv.deliver.body': 'Bruk dette når dokumentet allerede er levert til kunden på en annen måte. Ingen e-post sendes fra Plumme. Bokføring, MVA og betalingsstatus endres ikke, men påminnelser om usendt dokument stopper.',
  'inv.delivery.external': 'Levert utenfor Plumme',
  'inv.more': 'Mer',
  'inv.err.offerAlreadyConverted': 'Tilbudet er allerede konvertert til denne dokumenttypen.',
  'sale.totalDiscount': 'Totalrabatt',
  'sale.totalDiscountHelp': 'Fordeles forholdsmessig på alle produktlinjer og lagres med sporbar fordeling.',

  'sale.det.currency': 'Dokumentvaluta',
  'sale.det.exchangeRate': 'Kurs til {currency}',
  'sale.det.exchangeRateDate': 'Kursdato',
  'sale.det.exchangeRateSource': 'Kilde for kurs',
  'sale.det.exchangeRateSourcePh': 'For eksempel Norges Bank eller avtalt kurs',
  'sale.create.needCurrencyEvidence': 'Oppgi en positiv kurs, kursdato og kilde før fakturaen opprettes.',
  'sale.preview.accountingAmount': 'Regnskapsbeløp: {amount} {currency} · kurs {rate}',
  'sale.preview.vatAccountingAmount': 'MVA i {currency}: {amount}',
  'inv.pay.originalAmount': 'Beløp i {currency}',
  'inv.pay.bankAmountCurrency': 'Bankbeløp i {currency}',
  'inv.pay.fxPreview': 'Fordringen lukkes med {receivable} {accountingCurrency}. Differansen mot bankbeløpet føres som {kind}: {difference}.',
  'inv.pay.fxGain': 'valutagevinst',
  'inv.pay.fxLoss': 'valutatap',
});
